export const RESIDENCE_CONTENT_LIST = [
    {
        label: "Walls",
    },
     {
        label: "Driveway",
    },
    {
        label: "Ceilings",
    },
     {
        label: "Carpet",
    },
    {
        label: "Floors",
    },
    {
        label: "Stairs/Railings",
    },
    {
        label: "Doors Frames",
    },
    {
        label: "Lawn",
    },
    {
        label: "Others",
    },
  
];

export const PRE_DEPARTURE_CHECK = [
    {
        label: "All items loaded",
    },
     {
        label: "Received dismantling fixings",
    },
    {
        label: "Any new damages",
    },
];

export const PRE_DEPARTURE_CHECK_SECOND = [
    {
        label: "I have checked that the vehicles are empty",
    },
     {
        label: "Job has been unloaded and completed to my satisfaction",
    },
    
];

export const BEDROOMS = [
    {
        label: "Bed 1",
    },
     {
        label: "Bed 2",
    },
    {
        label: "Bed 3",
    },
    {
        label: "Bed 4",
    },
    {
        label: "Bed 5",
    },
    {
        label: "Bed 6",
    }
];

export const WC = [
    {
        label: "Bathroom",
    },
     {
        label: "Toilet",
    },
    {
        label: "En-suite",
    },
    {
        label: "Other",
    },
];

export const MISCELLANEOUS = [
    {
        label: "Kitchen",
    },
     {
        label: "Living Room",
    },
    {
        label: "Hallway",
    },
    {
        label: "Landing",
    },
    {
        label: "Dining Room",
    },
    {
        label: "Office",
    },
    {
        label: "Loft",
    },
    {
        label: "Other",
    }
];

export const EXTERIOR = [
    {
        label: "Garage",
    },
    {
        label:"Conservatory",
    },
    {
        label: "Shed",
    },
    {
        label: "Other",
    }
];